module.exports = __webpack_public_path__ + "static/media/tachometer.0a81e9ab.svg";